import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectAccountUsersVM, AccountUsersContext } from './account-users.context';
import { AccountUsersVM } from './account-users.viewmodel';
import AccountUsersList from './_account-users-list/account-users-list';

interface IProps {
    vm: AccountUsersVM;
}

const AccountUsersContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <AccountUsersList vm={vm} />;
};

const AccountUsersConnected = connectAccountUsersVM<IProps>(AccountUsersContainer, vm => ({ vm: vm }));

export const AccountUsers = moduleHost(AccountUsersVM, AccountUsersContext, AccountUsersConnected);